import React, {Fragment} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import * as api from "../../apis/externalSystem";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import useAntTable from "../../utils/useAntTable";
import withAuth from "../../utils/withAuth";
import {Button, Divider, Popconfirm, Space} from "antd";
import ModifyModal from "./modifyModal";
import useFormModal from "../../utils/useFormModal";
import {useRequest} from "ahooks";

const AddButton = withAuth('add', Button)
const EditFragment = withAuth('edit', Fragment)
const DeletePopconfirm = withAuth('delete', Popconfirm)

function ExternalSystem() {

    const {tableProps, refresh} = useAntTable(api.getSystems, {})

    const {modalProps, setVisible} = useFormModal({
        onRequest: api.modifySystem,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const {run: onDelete} = useRequest(api.deleteSystem, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '外部系统名称',
            dataIndex: 'name'
        },
        {
            title: '外部系统地址',
            dataIndex: 'api',
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>编辑</a>
                        <Divider type={'vertical'}/>
                    </EditFragment>
                    <DeletePopconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>新增</AddButton>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
        </PageHeaderLayout>
    )
}

export default ExternalSystem
